import { takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

//import { LOGOUT } from './constants';


// Individual exports for testing
export default function* mainLayoutSaga() {
  // See example in containers/HomePage/saga.js
}
